export default __webpack_public_path__ + "static/media/homeimage.53ce5458.png";